export var Labels={paymentProcessing:"\u6c7a\u6e08\u51e6\u7406\u4e2d"};